<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 210px">
        <p>供应商：</p>
        <el-input v-model="nameIpt" size="mini" style="width:150px" placeholder="请输入供应商"/>
      </div>
      <div class="navContainer">
        <p>类型：</p>
        <el-select v-model="typeIpt" size="mini" filterable style="width:150px" placeholder="请选择">
          <el-option v-for="item in typeOption" :key="item.value" :label="item.name" :value="item.value"/>
        </el-select>
      </div>
      <!-- <div class="navContainer" style="width: 230px">
        <p>所在区域：</p>
        <el-cascader v-model="areaIpt" filterable :options="regionList" style="width:150px" :props="{
                        expandTrigger: 'hover',
                        value: 'id',
                        label: 'cityName',
                        children: 'children',
                        multiple: false,
                      }" size="mini" collapse-tags clearable placeholder="请选择所在区域" ref="areaCascader"
        />
      </div> -->
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" size="mini" filterable style="width:150px" placeholder="请选择">
          <el-option v-for="item in stateOption" :key="item.value" :label="item.name" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px" type="index"/>
          <el-table-column prop="supplierName" label="供应商名称" align="center"/>
          <!-- <el-table-column prop="supplierNameShort" label="供应商简称" align="center" width="200"/> -->
          <el-table-column label="类型" align="center" width="150">
            <div slot-scope="scope">{{getType(scope.row.type)}}</div>
          </el-table-column>
          <!-- <el-table-column prop="telephone" label="电话" width="150" align="center"/> -->
          <!-- <el-table-column prop="area" label="所在区域" align="center" width="150"/> -->
         <el-table-column prop="address" label="详细地址" align="center" show-overflow-tooltip/>
          <el-table-column prop="state" label="状态" align="center" width="120">
            <div slot-scope="scope">{{getState(scope.row.status)}}</div>
          </el-table-column>
          <!-- <el-table-column label="车道管理" width="120" align="center">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" type="primary" @click="vehicleLane(scope.row)" class="yellow-bg">车道</el-button>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" width="210" align="center">
            <template slot-scope="scope">
              <div>
                <el-button v-if="scope.row.status" size="mini" type="danger" @click="disableClick(scope.row.id)">禁用</el-button>
                <el-button v-else size="mini" type="primary" @click="enableClick(scope.row.id)">启用</el-button>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
                <el-button size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">修改</el-button>

              </div>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='550px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <!-- <p :style="getStyle(detailData.status)">{{getState(detailData.status)}}</p> -->
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">供应商全称：</span>
              <span>{{detailData.supplierName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">供应商简称：</span>
              <span>{{detailData.supplierNameShort}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">类型：</span>
              <span>{{getType(detailData.type)}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">邮箱：</span>
                <span>{{detailData.mailbox}}</span>
              </div>
              <div>
                <span class="span1">电话：</span>
                <span>{{detailData.telephone}}</span>
              </div>
            </div>
            <div v-for="item in detailData.person">
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">对接人姓名：</span>
                  <span>{{item.name}}</span>
                </div>
                <div>
                  <span class="span1">对接人电话：</span>
                  <span>{{item.tell}}</span>
                </div>
              </div>
              <div class="baseInfoContentItem">
                <span class="span1">对接人职位：</span>
                <span>{{item.position}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="operationName" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 新增/修改 -->
    <transition name="el-fade-in-linear">
      <popup :title="dialogTitle" :show.sync="dialogVisible" width='650' center @close="dialogClose" :close-on-click-modal="false">
        <div class="company">
          <el-form :model="companyData" label-width="95px" :rules="rules" ref="ruleForm">
            <div-border label="基础信息">
              <el-row>
                <el-col>
                  <el-form-item label="供应商全称：" prop="fullName" style="margin-top: 10px;">
                    <el-input
                      :style="'width:100%'"
                      v-model="companyData.fullName"
                      placeholder="请输入供应商全称"
                      autocomplete="off"
                      size="mini"
                    />
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="供应商简称：" prop="name2">
                    <el-input
                      :style="'width:100%'"
                      v-model="companyData.name2"
                      placeholder="请输入供应商简称"
                      autocomplete="off"
                      size="mini"
                    />
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="类型：" prop="type">
                    <el-radio-group v-model="companyData.type">
                      <el-radio v-for="item in typeOption2" :key="item.value" :label="item.value">{{item.name}}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="邮箱：" prop="mail">
                    <el-input
                      :style="'width:100%'"
                      v-model="companyData.mail"
                      placeholder="请输入邮箱"
                      autocomplete="off"
                      size="mini"/>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="电话：" >
                    <el-input
                      :style="'width:100%'"
                      v-model="companyData.tell"
                      placeholder="请输入电话"
                      autocomplete="off"
                      size="mini"/>
                  </el-form-item>
                </el-col>
                <!-- <el-col v-if="companyData.type==2">
                  <el-form-item label="父级港口：" prop="parentPortName">
                    <el-select v-model="companyData.parentPortName" filterable placeholder="请选择" size="mini" style="width:100%" value-key="id">
                      <el-option v-for="item in typeOption3" :key="item.id" :label="item.supplier_name" :value="item" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col v-if="companyData.type==1"> -->
                <!-- <el-col>
                  <el-form-item label="所在区域：" prop="area">
                    <el-cascader v-model="companyData.area" :options="regionList" style="width:100%" 
                    :props="{
                      expandTrigger: 'hover',
                      value: 'id',
                      label: 'cityName',
                      children: 'children',
                      multiple: false,
                    }"
                    size="mini" collapse-tags clearable placeholder="请选择所在区域" ref="areaCascader" filterable @change="cascaderChange"/>
                  </el-form-item>
                </el-col> -->
                <el-col>
                  <el-form-item label="详细地址：" prop="address">
                    <el-input
                      v-model="companyData.address"
                      placeholder="请输入详细地址"
                      autocomplete="off"
                      size="small" />
                   <!-- <div style="display: flex;cursor: pointer;align-items: center;" @click="mapVisible=true">
                     <el-input
                       :disabled="true"
                       style="width:90%;margin-right: 10px;"
                       v-model="companyData.address"
                       placeholder="点击选择详细地址"
                       autocomplete="off"
                       size="small" />
                     <i class="el-icon-location"/>
                   </div> -->
                  </el-form-item>
                </el-col>
                <div v-for="(item,index) in companyData.person" :key="index">
                  <el-col :span="12">
                    <el-form-item label="对接人姓名：" :prop="`person.${index}.name`" :rules="rules.name" style="margin-bottom: 15px">
                      <el-input
                        :style="'width:100%'"
                        v-model="item.name"
                        placeholder="请输入对接人姓名"
                        autocomplete="off"
                        size="small"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="对接人电话：" :prop="`person.${index}.tell`" :rules="rules.tell">
                      <el-input
                        :style="'width:100%'"
                        v-model="item.tell"
                        placeholder="请输入对接人电话"
                        autocomplete="off"
                        size="small"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="对接人职位：" :prop="`person.${index}.position`" :rules="rules.position" style="margin-bottom: 17px">
                      <div style="display:flex;align-items:center;">
                        <el-input
                          :style="'width:40%'"
                          v-model="item.position"
                          placeholder="请输入对接人职位"
                          autocomplete="off"
                          size="small"
                        />
                        <div style="display:flex;align-items:center;margin-left: 25px;" v-if="index===companyData.person.length-1">
                          <el-button
                            style="margin-left: 10px;height: 22px;width: 22px;display: flex;align-items: center;justify-content: center;padding: 0;"
                            size="mini"
                            type="info"
                            icon="el-icon-plus"
                            circle
                            @click="levelAdd"
                          />
                          <el-button
                            v-if="companyData.person.length!==1"
                            style="height: 22px;width: 22px;display: flex;align-items: center;justify-content: center;padding: 0;"
                            size="mini"
                            type="info"
                            icon="el-icon-minus"
                            circle
                            @click="levelMinus"
                          />
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </div>
              </el-row>
            </div-border>
            <div class="btnContainer">
              <el-button class="searchBtn" size="medium" :loading="addLoad" @click="addClick">确认</el-button>
              <el-button class="resetBtn" size="medium" @click="dialogClose">关闭</el-button>
            </div>
          </el-form>
        </div>
      </popup>
    </transition>
    <transition name="el-fade-in-linear">
      <popup width="850" title="详细地址" :show.sync="mapVisible" center>
        <web-map :useType="'select'" @close="mapClose" v-if="mapVisible" :address="companyData.address"/>
      </popup>
    </transition>
    <!-- 车道 -->
    <el-dialog v-if="cabinVisible" title="车道管理" :visible.sync="cabinVisible" width="650px" center >
      <div class="cabin">
        <div style="margin: 0 0 10px 0">
          <el-button size="mini" class="searchBtn" @click="cabinAdd">添加</el-button>
        </div>
        <el-table
          v-loading="cabinLoad"
          :data="cabinTable"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{'color':'#7F7F7F','font-size':'13px','height':'48px',}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column
            type="index"
            :index="tableIndexMethod"
            label="序号"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column prop="portName" label="车道名" align="center"/>
          <el-table-column prop="status" label="状态" align="center"/>
          <el-table-column prop="capacity" label="可停车数量" align="center" width="100"/>
          <el-table-column prop="freeNumber" label="空闲数量" align="center"/>
          <el-table-column  label="操作" align="center" width="210px">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" class="yellow-bg" @click="cabinChangeClick(scope.row)">修改</el-button>
              <el-button size="mini" :type="scope.row.status !=='启用' ? 'primary':'danger'" @click="cabinEnableClick(scope.row)">{{scope.row.status !=='启用'?'启用':'禁用'}}</el-button>
              <el-button size="mini" type="primary" @click="deleLines(scope.row.id)" class="resetBtn">删除</el-button>
            </template>

          </el-table-column>


        </el-table>
        <el-pagination
          style="margin-top: 10px;"
          @size-change="contractSizeChanges"
          @current-change="contractCurrentChanges"
          :current-page.sync="cabinFrom.page"
          :page-size="cabinFrom.rows"
          :page-sizes="[10, 20, 30, 40]"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="cabinTotal"
        >
        </el-pagination>

        <el-dialog :title="`${cabinDialogName}车道`" :visible.sync="cabinAddVisible" append-to-body center width="680px" @close="cabinDialogClose">
          <div style="padding: 20px">
            <el-form :model="cabinData" label-width="110px" :rules="cabinRules" ref="cabinRuleForm" size="medium">
              <el-form-item label="车道名:" prop="cabinName">
                <el-input size="mini" v-model="cabinData.cabinName" style="width: 300px"></el-input>
              </el-form-item>
              <el-form-item label="可停车数量:" prop="boatNumber">
                <el-input size="mini" v-model="cabinData.boatNumber" style="width: 300px"></el-input>
              </el-form-item>
              <!--              <el-form-item label="空闲数量:" prop="freeNumber">-->
              <!--                <el-input size="mini" v-model="cabinData.freeNumber" style="width: 300px"></el-input>-->
              <!--              </el-form-item>-->
              <el-form-item label-width="0px" style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: center;">
                <el-button class="searchBtn" size="mini"  @click="cabinAddClick">确认</el-button>
                <el-button class="resetBtn" size="mini" @click="cabinDialogClose">关闭</el-button>
              </el-form-item>
            </el-form>
          </div>

        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import webMap from '@/components/map'
  import popup from "@/components/popup";
  import {formatDateTime, getSessionStore, removeSpace} from "@/config/mUtils";
  import divBorder from "@/components/divBorder";
  import {
    supplierPortOtherPageList,
    supplierPortOtherIsEnable,
    supplierPortOtherDetail,
    typeSelectList,
    supplierPortOtherAdd,
    supplierPortOtherUpdate,
    vLine,
    deleLine,
    startend,
    addLine,
    changeLine,
  } from "@/service/basicfile"

  export default {
    components: {
      divBorder,
      webMap,
      popup,
    },
    data() {
      const validateTell = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入对接人联系手机号'));
        } else if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/).test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      };
      return {
        cabinDialogName:'添加',
        cabinTable:[],
        cabinLoad:false,
        cabinTotal:0,
        cabinAddVisible:false,
        cabinRules:{
          cabinName:{ required: true, message: '请输入车道名', trigger: 'blur' },
          boatNumber:{ required: true, message: '请输入可停车数量', trigger: 'blur' },
          freeNumber:{ required: true, message: '请输入空闲数量', trigger: 'blur' },
        },
        cabinData:{
          shipId:'',
          cabinName:'',
          boatNumber:'',
          freeNumber:'',
        },
        portIds:'',
        cabinFrom:{
          rows:10,
          page:1,
        },
        cabinVisible:false,
        mapVisible:false,
        nameIpt:'',
        typeIpt:'',
        areaIpt:'',
        stateIpt:'',
        regionList: [],
        typeOption:[{value:'',name:'全部'},{value:'1',name:'港口'},{value:'2',name:'其它'}],
        typeOption2:[{value:'1',name:'港口'},{value:'2',name:'其它'}],
        typeOption3:[],
        stateOption:[{value:'',name:'全部'},{value:'1',name:'启用中'},{value:'0',name:'禁用中'}],
        page:1,
        size:10,
        total:0,
        tableLoad:false,
        TableDatas:[],
        detailDialogVisible:false,
        detailData:{},
        operationData:[],
        dialogTitle:'',
        dialogVisible:false,
        addLoad:false,
        companyData:{
          warehouse:'',
          address:'',
          free:'',
          unit:0,
          price:'',
          unit2:0,
          type: 1,
          person:[
            {name:'',tell:'',position:'',},
          ],
        },
        rules:{
          fullName:[
            { required: true, message: '请输入供应商全称', trigger: 'blur' },
          ],
          name2:[
            { required: true, message: '请输入供应商简称', trigger: 'blur' },
          ],
          area:[
            { required: true, message: '请选择所在区域', trigger: 'change' },
          ],
          address:[
            { required: true, message: '请输入详细地址', trigger: 'blur' },
          ],
          type:[
            { required: true, message: '请选择类型', trigger: 'change' },
          ],
          parentPortName:[
            { required: true, message: '请选择父级港口', trigger: 'change' },
          ],
          mail: [
            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur'] }
          ],
          tell1:[
            { validator:validateTell, message: '请输入正确的手机号', trigger: 'blur' },
          ],
          name:[
            { required: true, message: '请输入对接人姓名', trigger: 'blur' },
          ],
          tell:[
            { required: true, validator:validateTell, message: '请输入正确的手机号', trigger: 'blur' },
          ],
          position:[
            { required: true, message: '请输入对接人职位', trigger: 'blur' },
          ],
        },
      };
    },
    computed:{
      getTime(){
        return function(time){
          return formatDateTime(time,'yyyy年mm月dd日 hh:ii:ss')
        };
      },
      getType(){
        return function(state){
          switch(state) {
            case 1:
              return '港口'
            case 2:
              return '其它'
          }
        };
      },
      getState(){
        return function(state){
          switch(state) {
            case 1:
              return '启用中'
            case 0:
              return '禁用中'
          }
        };
      },
      getStyle() {
        return (val) => {
          switch (val) {
            case 1:
              return 'color: #3388ff'
            case 0:
              return 'color:#F56C6C;'
          }
        }
      },
    },
    mounted() {
      this.init();

    },
    methods: {
      tableIndexMethod(index) {
        return this.cabinFrom.rows * (this.cabinFrom.page - 1) + index + 1;
      },
      // 车道 -- 关闭弹窗
      cabinDialogClose(){
        this.$refs.cabinRuleForm.resetFields()
        this.cabinData={
          shipId:'',
          cabinName:'',
          boatNumber:'',
          freeNumber:'',
        }
        this.cabinAddVisible = false
      },
      // 车道 -- 打开弹窗
      vehicleLane(item){
        console.log(item);
        this.cabinVisible=true;
        this.portIds=item.id
        this.lineserch();
      },
      // 车道 -- 分页查询
      lineserch(){
        const data = {
          portId:this.portIds,
          page:this.cabinFrom.page,
          rows:this.cabinFrom.rows,
        }
        this.vLanes(data)
      },
      async vLanes(data){
        const res =await vLine(data);
        console.log(res);
        if (res.status===0){
          this.cabinTable=[];
          res.data.records.forEach((item)=>{
            if (item.status===1){
              item.status='启用'
            }else {
              item.status='禁用'
            }
            this.cabinTable.push(item)
          })
          this.cabinTotal=res.data.total
        }else this.$message.warning(res.message)
      },
      contractSizeChanges(sizes){
        this.cabinFrom.rows=sizes;
        this.lineserch();
      },
      contractCurrentChanges(page){
        this.cabinFrom.page=page;
        this.lineserch();
      },
      // 车道 -- 删除
      async deleLines(ids){
        const id = {
          id:ids
        }
        const res = await deleLine(id)
        console.log(res);
        if(res.status===0){
          this.lineserch();
          this.$message.success(res.message)
        }else this.$message.warning(res.message)
      },
      //1启用，0禁用
      cabinEnableClick(ret){
        console.log(ret);
        if (ret.status==='启用'){
          ret.status='0'
        }else {
          ret.status='1'
        }
        const data = {
          id:ret.id,
          statusNum:ret.status
        }
        this.startends(data)
      },
      // 车道 -- 调用启用/禁用接口
      async startends(data){
        const res =await startend(data);
        console.log(res);
        if(res.status===0){
          this.$message.success(res.message)
        }else this.$message.warning(res.message)
        await this.lineserch();
      },
      // 车道 -- 添加打开弹窗
      cabinAdd(){
        this.cabinAddVisible =true
        this.cabinDialogName = '添加'
      },
      // 车道 -- 调用添加车道接口
      async addLines(data){
        const res =await addLine(data);
        console.log(res);
        if(res.status===0){
          this.$message.success(res.message)
        }else this.$message.warning(res.message)
      },
      // 车道 -- 确认添加接口
      cabinAddClick(){
        this.$refs.cabinRuleForm.validate(async (valid) => {
          if (valid){
            if(this.cabinDialogName === '修改'){
              const data={
                id:this.cabinData.id,
                portName:this.cabinData.cabinName,
                capacity:this.cabinData.boatNumber,
              }
              this.changeLines(data)
              this.cabinDialogClose();
              this.lineserch();
            }else {
              const data={
                portId:this.portIds,
                portName:this.cabinData.cabinName,
                capacity:this.cabinData.boatNumber,
              }
              this.addLines(data);
              this.cabinDialogClose();
              this.lineserch();
            }
          }else {
          }
        })
      },
      // 车道 -- 修改打开弹窗
      cabinChangeClick(item){
        this.cabinAddVisible =true
        this.cabinDialogName = '修改'
        this.cabinData = {
          id:item.id,
          cabinName:item.portName,
          boatNumber:item.capacity,
        }
      },
      // 车道 -- 调用修改接口
      async changeLines(data){
        const res = await changeLine(data);
        if (res.status===0){
          this.$message.success(res.message)
        }else this.$message.warning(res.message)

      },
      // 关闭地图弹窗
      mapClose(val, lnglat){
        console.log(val,'val')
        console.log(lnglat,'lnglat')
        this.companyData.address=val;
        this.companyData.longitude=lnglat[0];
        this.companyData.latitude=lnglat[1];
        this.mapVisible=false;
      },
      async init(){
        await this._supplierPortOtherPageList();
        this.regionList = JSON.parse(getSessionStore("areaList"))
        // const res = await typeSelectList();
        // if(res.status !== 0) return this.$message.error(res.message);
        // this.typeOption=[{value:'',name:'全部',},...res.data];
        // this.typeOption2=res.data;
      },
      // 分页查询
      async _supplierPortOtherPageList(){
        this.tableLoad=true;
        let str =this.areaIpt[this.areaIpt.length-1];
        // this.areaIpt?this.areaIpt.forEach(item=>str+=item+','):null
        // str = str[str.length-1]===','?str.slice(0,str.length-1):str;
        const obj={
          supplierName:this.nameIpt,
          type:this.typeIpt,
          areaId:str,
          status:this.stateIpt,
          page:this.page,
          rows:this.size,
        }
        const res = await supplierPortOtherPageList(obj);
        this.tableLoad=false;
        if(res.status !== 0) return this.$message.error(res.message);
        this.TableDatas=res.data.records;
        this.total=res.data.total;
      },
      // 新增/修改 -- 删除对接人信息
      levelMinus(){
        this.companyData.person.pop();
      },
      // 新增/修改 -- 新增对接人信息
      levelAdd(){
        this.companyData.person.push({name:'',tell:'',position:'',})
      },
      contractSizeChange(sizes){
        this.size=sizes;
        this._supplierPortOtherPageList();
      },
      contractCurrentChange(page){
        this.page=page;
        this._supplierPortOtherPageList();
      },

      // 详情
      async detailClick(id){
        this.detailDialogVisible=true;
        const res = await supplierPortOtherDetail(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.operationData=res.data.operateRecordList;
        const nameArr = res.data.directorName.split(',');
        const tellArr = res.data.directorMobile.split(',');
        const positionArr = res.data.directorPost.split(',');
        const arr = nameArr.map((item,index)=>{
          return {
            name:item,
            tell:tellArr[index],
            position:positionArr[index],
          }
        })
        this.detailData= {
          ...res.data,
          person:arr,
        };
      },
      // 修改 -- 打开弹窗
      async changeClick(item){
        const arr1 = item.directorName.split(',');
        const arr2 = item.directorMobile.split(',');
        const arr3 = item.directorPost.split(',');
        const arr = arr1.map((item,index)=>{
          return {
            name:item,
            tell:arr2[index],
            position:arr3[index],
          }
        })
        this.companyData={
          ...item,
          fullName: item.supplierName,
          name2: item.supplierNameShort,
          mail: item.mailbox,
          tell: item.telephone,
          type: item.type +'',
          person: arr,
        };
        this.dialogTitle='修改港口及其它供应商';
        this.dialogVisible=true;
      },
      // 查询
      searchBtn(){
        this.page = 1;
        this._supplierPortOtherPageList();
      },
      // 重置
      resetBtn(){
        this.nameIpt='';
        this.areaIpt='';
        this.stateIpt='';
        this.typeIpt='';
      },
      // 新增 -- 打开弹窗
      async addBtn(){
        this.dialogTitle='新增港口及其它';
        this.dialogVisible=true;
        this.companyData={
          person:[
            {name2:'',tell:'',position:'',},
          ],
        };
      },
      // 新增/修改 -- 确认
      addClick(){
        this.companyData=removeSpace(this.companyData);
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            let str ='';
            this.typeOption2.forEach(item=>{if(item.value === this.companyData.type) str=item.name})
            // let str2='';
            // this.companyData.area.forEach(item=>str2+=item+',')
            // str2=str2.slice(0,str2.length-1)
            // const res2 = await getRegionName(str2);
            // if(res2.status !== 0) return this.$message.error(res2.message);
            let nameStr = '';
            let tellStr = '';
            let positionStr = '';
            this.companyData.person.forEach(item=>{
              nameStr+=item.name+',';
              tellStr+=item.tell+',';
              positionStr+=item.position+',';
            })
            nameStr = nameStr[nameStr.length-1]===','?nameStr.slice(0,nameStr.length-1):nameStr;
            tellStr = tellStr[tellStr.length-1]===','?tellStr.slice(0,tellStr.length-1):tellStr;
            positionStr = positionStr[positionStr.length-1]===','?positionStr.slice(0,positionStr.length-1):positionStr;
            this.addLoad = true;
            const obj = {
              id:this.companyData.id,
              supplierName:this.companyData.fullName,
              supplierNameShort:this.companyData.name2,
              type:this.companyData.type,
              typeName:str,
              mailbox:this.companyData.mail,
              telephone:this.companyData.tell,
              address:this.companyData.address,
              // longitude:this.companyData.longitude,
              // latitude:this.companyData.latitude,
              // parentPortName:this.companyData.parentPortName ? this.companyData.parentPortName.supplier_name:'',
              // parentPortId:this.companyData.parentPortName ? this.companyData.parentPortName.id:'',
              directorName:nameStr,
              directorMobile:tellStr,
              directorPost:positionStr,
              // areaId:this.companyData.area[this.companyData.area.length -1],
              // areaFullId:this.companyData.area.join('/'),
              // area:res2.data,
              // coordinate:this.companyData.center
            };
            const res = this.dialogTitle==='新增港口及其它'?await supplierPortOtherAdd(obj):await supplierPortOtherUpdate(obj);
            this.addLoad = false;
            if(res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.dialogVisible=false;
            await this._supplierPortOtherPageList();
          } else return false;
        });
      },
      // 新增/修改 -- 关闭弹窗(取消)
      dialogClose(){
        this.dialogVisible=false;
        this.$refs.ruleForm.resetFields();
      },
      // 新增/修改 -- 区域改变
      cascaderChange(){
        this.$nextTick(()=>{
          console.log(this.$refs.areaCascader.getCheckedNodes())
          this.companyData.center = this.$refs.areaCascader.getCheckedNodes()[0].data.center
          console.log(this.$refs.areaCascader.getCheckedNodes()[0].data.center)
        })



      },
      // 启用
      enableClick(id){
        this.$confirm('确定要启用当前供应商吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await supplierPortOtherIsEnable(id);
          if(res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          await this._supplierPortOtherPageList();
        }).catch(() => {});
      },
      // 禁用
      disableClick(id){
        this.$confirm('确定要禁用当前供应商吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await supplierPortOtherIsEnable(id);
          if(res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          await this._supplierPortOtherPageList();
        }).catch(() => {});
      },
    },
  };
</script>



<style lang="scss" scoped>
  .mainContainer{
    width:100%;
    padding:20px 15px 0 25px;
    background-color: #fff;
    .line{
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }
    .line +span{
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }
    .nav{
      width:100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      &Container{
        width:200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;
        p{
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }
      &Btn{
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }
    .content{
      display: flex;
      flex-direction: column;
      align-items: center;
      .tableContainer{
        margin-top: 15px;
        margin-bottom: 25px;
        width: 100%;
        ::v-deep{
          .el-table .cell {
            padding: 0;
          }
          .el-table th{
            padding: 0;
          }
          .el-table td{
            padding: 0;
          }
        }
      }
      .paginationContainer{
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        span{
          font-size: 13px;
        }
      }
    }
    .detail{
      width: 100%;
      padding: 10px 0 20px 20px;
      .baseInfo{
        display: flex;
        flex-direction: column;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Content{
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          padding:20px 23px 0 23px;
          &Item{
            margin-bottom: 20px;
            .span1{
              font-weight: 700;
            }
            span{
              font-size: 14px;
            }
            .specialOne{
              width:50%;
            }
          }
          .specialItem{
            display:flex;
          }
        }
      }
      .operation{
        display: flex;
        flex-direction: column;
        ::v-deep{
          .el-table td, .el-table th{
            padding:0;
          }
          .cell{
            font-size: 10px;
            padding:0;
          }
        }
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Table{
          width:100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }
    .company{
      width:100%;
      padding: 20px 10px;
      .unitContainer{
        display: flex;
        align-items:center;
        //justify-content:space-between;
        //width:140px;
        margin-bottom:5px;
        ::v-deep{
          .el-input__inner{
            border: 1px solid #DCDFE6;
          }
        }
      }
      .unitContainer2{
        display: flex;
        align-items:center;
        //justify-content:space-between;
        //width:189px;
        margin-bottom:5px;
        span{
          color: #606266;
          font-weight: 700;
        }
        ::v-deep{
          .el-input__inner{
            border: 1px solid #DCDFE6;
          }
        }
      }
      ::v-deep{
        .el-form-item__label{
          font-weight: 700;
        }
        .el-form-item__label{
          padding:0;
        }
        .el-form-item__content{
          position: relative;
        }
        .el-form-item{
          margin-bottom:13px;
        }
      }
      .btnContainer{
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        button{
          margin: 0 15px;
        }
      }
    }
    ::v-deep{
      .el-table th>.cell{
        font-weight: 700!important;
      }
    }
    .cabin{
      padding: 25px;
      width: 100%;
    }
  }
  ::v-deep{
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }
    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }
    .el-dialog__headerbtn{
      top:9px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
</style>
